import React from 'react';
import classnames from 'classnames';

import styles from './featuredResearchStyles';

import Card from 'buyside/components/presentation/Card/card';
import RecentIdea from 'buyside/components/presentation/RecentIdea/recentIdea';
import RecentWhitePaper from 'buyside/components/presentation/RecentWhitePaper/RecentWhitePaper';
import Expandable from 'buyside/components/presentation/Expandable/expandable';
import DelayedAccessAlert, {
  Location
} from 'buyside/components/presentation/AccessControl/delayedAccessAlert';

import { defaultUserImageUrl } from 'buyside/util/urlHelper';

const FeaturedResearch = ({
  fundProfile: { featuredResearch, featuredWhitePaperResearch },
  createAuditRecord,
  roleIsAdmin,
  showUserDetails,
  shrink
}) => {
  return (
    <div>
      {Boolean(featuredResearch.length) && (
        <>
          {roleIsAdmin ? null : <DelayedAccessAlert id={Location.fundResearch} isPublic={false} />}
          <div className={classnames(styles.featuredResearchItems, { [styles.narrow]: shrink })}>
            <h4>FEATURED IDEAS</h4>
            <Expandable maxItems={4}>
              {featuredResearch.map(idea => (
                <Card key={idea.id} customStyles={styles.researchCard}>
                  <RecentIdea
                    idea={idea}
                    showUserDetails={showUserDetails}
                    showEntityName
                    onIdeaLinkClick={() => createAuditRecord(idea.id, 'Idea', 'click')}
                    onUserLinkClick={() => createAuditRecord(idea.user.id, 'User', 'click')}
                  />
                </Card>
              ))}
            </Expandable>
          </div>
        </>
      )}
      {Boolean(featuredWhitePaperResearch.length) && (
        <div className={classnames(styles.featuredResearchItems, { [styles.narrow]: shrink })}>
          <h4>FEATURED MACRO / THEMATIC RESEARCH</h4>
          <Expandable maxItems={4}>
            {featuredWhitePaperResearch.map(wp => {
              if (!wp) return null;
              const {
                elevatorPitch,
                esgNames,
                geographyNames,
                globalMacroNames,
                id,
                sectorNames,
                submittedAt,
                title,
                user: { id: userId, displayName, profileImageUrl }
              } = wp;
              if (!submittedAt) return null;
              return (
                <Card key={id} customStyles={styles.researchCard}>
                  <RecentWhitePaper
                    displayName={displayName}
                    elevatorPitch={elevatorPitch}
                    esgNames={esgNames}
                    geographyNames={geographyNames}
                    globalMacroNames={globalMacroNames}
                    id={id}
                    onWhitePaperLinkClick={() => createAuditRecord(id, 'WhitePaper', 'click')}
                    onUserLinkClick={() => createAuditRecord(userId, 'User', 'click')}
                    profileImageUrl={profileImageUrl || defaultUserImageUrl()}
                    sectorNames={sectorNames}
                    showUserDetails={showUserDetails}
                    submittedAt={submittedAt}
                    title={title}
                    userId={userId}
                  />
                </Card>
              );
            })}
          </Expandable>
        </div>
      )}
      <div className={styles.featuredResearchFooter}>
        <strong>Note:</strong> it should not be assumed that recommendations made in the future will
        be profitable, or will equal the performance of the securities in this list.
      </div>
    </div>
  );
};

export default FeaturedResearch;
